/* eslint-disable react/no-unknown-property */
import React from 'react';
import PageLayout from 'components/Layouts/PageLayout/PageLayout';
import { useAppSelector } from 'hooks';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { ServiceCode } from 'store/user/types/service';
import ServiceNoData from 'components/ServiceNoData/ServiceNoData';
import { ReactComponent as KuberIcon } from 'assets/icons_3/kubernetes.svg';

const KubernetesLayout = () => {
  const [t] = useTranslation();
  const user = useAppSelector((state) => state.user);
  const currentRegionId = user.region?.id;
  const kubernetesRegions = user.services
    .filter((service) => service.code === ServiceCode.k8s)
    .map((service) => service.regionId);

  if (currentRegionId && kubernetesRegions.includes(currentRegionId)) {
    return <Outlet />;
  }

  const availableRegions = kubernetesRegions.map((regionId) => user.regions.find((region) => region.id === regionId)?.name || '').filter((name) => name !== '');

  return (
    <PageLayout title={t('kuber.clusters')}>
      <ServiceNoData
        title={t('kuber.clusters')}
        icon={<KuberIcon />}
        descriptions={[`${t('no_data.region_disabled_1')} "${t('kuber.clusters')}" ${t('no_data.region_disabled_2', { availabilityZone: availableRegions.join(', ') })}.`]}
      />
    </PageLayout>
  );
};

export default KubernetesLayout;
